__turbopack_context__.v({
  "categoryIcon": "PlanComparisonTable-module__gpIWYa__categoryIcon",
  "categoryLabelWrapper": "PlanComparisonTable-module__gpIWYa__categoryLabelWrapper",
  "categoryRowValue": "PlanComparisonTable-module__gpIWYa__categoryRowValue",
  "categoryWrapper": "PlanComparisonTable-module__gpIWYa__categoryWrapper",
  "chevronIcon": "PlanComparisonTable-module__gpIWYa__chevronIcon",
  "comparisonSection": "PlanComparisonTable-module__gpIWYa__comparisonSection",
  "comparisonTitle": "PlanComparisonTable-module__gpIWYa__comparisonTitle",
  "dataRow": "PlanComparisonTable-module__gpIWYa__dataRow",
  "expandedContent": "PlanComparisonTable-module__gpIWYa__expandedContent",
  "gridRow": "PlanComparisonTable-module__gpIWYa__gridRow",
  "headerCell": "PlanComparisonTable-module__gpIWYa__headerCell",
  "headerRow": "PlanComparisonTable-module__gpIWYa__headerRow",
  "rowLabel": "PlanComparisonTable-module__gpIWYa__rowLabel",
  "rowLabelContainer": "PlanComparisonTable-module__gpIWYa__rowLabelContainer",
  "rowValue": "PlanComparisonTable-module__gpIWYa__rowValue",
  "tableContainer": "PlanComparisonTable-module__gpIWYa__tableContainer",
  "testName": "PlanComparisonTable-module__gpIWYa__testName",
  "testRow": "PlanComparisonTable-module__gpIWYa__testRow",
  "testValue": "PlanComparisonTable-module__gpIWYa__testValue",
});
